/* 🤖 this file was generated by svg-to-ts */
export const emperorIconInterfaceAlertTriangle: {
  name: 'interface_alert_triangle';
  data: string;
} = {
  name: 'interface_alert_triangle',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><g><path d="M21 22H3c-.347 0-.67-.18-.851-.48 -.19-.3-.2-.67-.05-.98l9-18c.33-.677 1.45-.677 1.78 0l9 18c.15.31.13.67-.05.97 -.19.29-.51.47-.85.47ZM4.61 20H19.38L11.99 5.237 4.6 20Z"/><path d="M11 10h2v6h-2Z"/><path d="M12 16.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 1 0 0-2.5Z"/></g></svg>`
};
